import { useRef, useState } from 'react';
import { Image } from 'lucide-react';
import { NButton, NInput, NTextarea, NRadioGroup, useToast, NSwitch } from 'nayan';
import { useAddCategoryMutation, useUpdateCategoryMutation } from '../../services/ImagesService';
import { compressFile, extendFormData, getFileName, getImageUrl } from '../../config/Config';
import { CONTENT_TYPES } from '../../services/DrawingsService.ts';

interface Props {
  category?: any;
  closeModal: any;
}

const categoryTypes = [
  { value: CONTENT_TYPES.IMAGES, label: CONTENT_TYPES.IMAGES },
  { value: CONTENT_TYPES.STORIES, label: CONTENT_TYPES.STORIES },
  { value: CONTENT_TYPES.PUZZLES, label: CONTENT_TYPES.PUZZLES }
];

const CategoriesNew = (props: Props) => {
  const { category } = props;
  const toast = useToast();
  const [content, setContent] = useState<any>(category?.content || CONTENT_TYPES.IMAGES);
  const [name, setName] = useState<any>(category?.name || '');
  const [details, setDetails] = useState<any>(category?.details || '');
  const [myFile, setFile] = useState<any>('');
  const [enabled, setEnabled] = useState(category?.enabled === 'YES');
  const [isLoading, setIsLoading] = useState(false);
  const inputImageRef = useRef<any>(null);
  const addCategoryMutation = useAddCategoryMutation();
  const updateCategoryMutation = useUpdateCategoryMutation();

  const getTempFile = () => {
    return URL.createObjectURL(myFile);
  };

  const onSave = async (e: any) => {
    e.preventDefault();
    if (!name || !details) {
      toast('Invalid data');
    }
    const resizeImg: any = await compressFile(myFile);
    const newData = Object.assign(
      {},
      !!category ? category : {},
      { enabled: enabled ? 'YES' : 'NO' },
      { name, details, content, type: 'CATEGORY' },
      !!myFile ? { file: getFileName(myFile.name), fileDetails: resizeImg.metadata } : {}
    );
    const formData = new FormData();
    !!myFile && formData.append('myFile', resizeImg.file);
    extendFormData(formData, newData);
    setIsLoading(true);
    if (!category?.uuid) {
      addCategoryMutation
        .mutateAsync(formData)
        .then(() => props.closeModal())
        .finally(() => setIsLoading(false));
    } else {
      updateCategoryMutation
        .mutateAsync({ uuid: category.uuid, formData })
        .then(() => props.closeModal())
        .finally(() => setIsLoading(false));
    }
  };

  return (
    <div className="p-3">
      <form onSubmit={onSave}>
        <div className="flex flex-row items-center mb-5">
          <img
            className="bg-background rounded-full border border-border w-[80px] h-[80px] mr-3"
            src={!!myFile ? getTempFile() : getImageUrl(category?.file)}
            alt=""
          />
          <div>
            <div>
              <input type="file" className="myFile hidden" accept="image/*" ref={inputImageRef} onChange={(e: any) => setFile(e.target.files[0])} />
              <span className="add-post-btn cursor-pointer flex items-center" onClick={() => inputImageRef.current && inputImageRef.current.click()}>
                <Image size="1.5em" className="text-primary" />
                <span className="pl-2 text-primary"> Change category image</span>
              </span>
            </div>
            <div className="text-muted text-sm mt-2">Select new image to change your category image.</div>
          </div>
        </div>

        <div className="mb-2">Choose category type</div>
        <NRadioGroup className="mb-5" label="Category Type" items={categoryTypes} selected={content} onChange={setContent} />
        <NInput className="mb-3" label="Category Name" value={name} onChange={e => setName(e.target.value)} />
        <NTextarea className="mb-3" label="Category Details" value={details} onChange={e => setDetails(e.target.value)} />
        <NSwitch className="mb-5" label="Is this category enabled?" enabled={enabled} onChange={setEnabled} />
        <NButton type="submit" className="w-full" isLoading={isLoading}>
          SUBMIT
        </NButton>
      </form>
    </div>
  );
};

export default CategoriesNew;
